import React, { useState } from "react";
import { Button, ClickAwayListener, Popper, Paper, Typography, Box } from "@material-ui/core";

const ReadMoreDialog = ({ title, triggerLabel = "View", content, placement="right" }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const isEmptyContent = (html) => {
        if (!html) return true;

        const text = html
            .replace(/<[^>]*>/g, "")
            .replace(/&nbsp;/g, "")
            .trim();

        return text.length === 0;
    };


    const hasContent = !isEmptyContent(content);

    return (
        <>
            <Button
                size="small"
                color="primary"
                onClick={handleClick}
                style={{ padding: 0, marginTop: 4 }}
            >
                {triggerLabel}
            </Button>

            <Popper
                open={open}
                anchorEl={anchorEl}
                placement={placement}
                disablePortal
                modifiers={{
                    offset: {
                        enabled: true,
                        offset: "0,10"
                    }
                }}
            >
                {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={handleClose}>
                        <Paper
                            id="read_more_popper"
                            elevation={4}
                            style={{
                                width: 400,
                                maxHeight: 450,
                                overflow: "auto",
                                padding: 12
                            }}
                        >
                            <Box
                                mb={1}
                                pb={0.5}
                                borderBottom="1px solid #eee"
                            >
                                <Typography variant="subtitle2">
                                    {title}
                                </Typography>
                            </Box>

                            {hasContent ? (
                                <div
                                    dangerouslySetInnerHTML={{ __html: content }}
                                    style={{
                                        fontSize: "0.85rem",
                                        lineHeight: 1.5
                                    }}
                                />
                            ) : (
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    align="center"
                                >
                                    No data available.
                                </Typography>
                            )}
                        </Paper>
                    </ClickAwayListener>
                )}
            </Popper>
        </>
    );
};

export default ReadMoreDialog;
